import { useEffect, useRef } from "react";
import useApiSource from "../../api/source";

export default function Activos() {  
    const apiSource = useApiSource();
  
    const apiRef = useRef(null);

    apiRef.current = {
        source: apiSource,
    };

    useEffect(() => {
        if (
            typeof window.mountActivos !==
            "function"
        ) {
            console.error(
                "No se encontró window.mountActivos. " +
                "Verifica que esté cargado ui-widget.iife.js."
            );

            return undefined;
        }

        console.log(
            "API entregada al microfrontend:",
            apiRef.current
        );

        console.log(
            "API Source:",
            apiRef.current?.source
        );

        const desmontar = window.mountActivos(
            "activos",
            {
                api: apiRef.current,
            }
        );

        return () => {
            if (typeof desmontar === "function") {
                desmontar();
            }
        };
    }, []);

    return <div id="activos" />;
}